import axios, { baseURL } from '@axios'
import { paginateArray, sortCompare } from '@/common'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        console.log('qqq', queryParams)
        axios
          .get(`${baseURL}/api/User/Get`)
          .then(response => {
            const {
              q = '',
              perPage = 10,
              page = 1,
              sortBy = 'userId',
              sortDesc = false,
              status,
            } = queryParams

            let dataFromAPI = response.data.data

            /*
              { key: 'userCode', label: 'รหัสผู้ใช้งาน (User)', sortable: true },
    { key: 'userName', label: 'username', sortable: true },
    // { key: 'firstName', label: 'First Name', sortable: true },
    // {
    //   key: 'currentPlan',
    //   label: 'Last Name',
    //   formatter: title,
    //   sortable: true,
    // },
    { key: 'firstName', label: 'ชื่อ', sortable: true },
    { key: 'lastName', label: 'นามสกุล', sortable: true },
    // { key: 'role', label: 'ประเภทผู้ใช้งาน', sortable: true },
    { key: 'status', label: "สถานะ", sortable: true },
    */

            if (q !== '' && q !== null) {
              const queryLowered = q.toLowerCase()
              const result = []
              dataFromAPI.forEach(x => {
                console.log(x)
                const userCode = x.userCode || ''
                const userName = x.userName || ''
                const firstName = x.firstName || ''
                const lastName = x.lastName || ''
                const _status = x.status || ''

                if (userCode.toString().toLowerCase().includes(queryLowered)
        || userName.toString().toLowerCase().includes(queryLowered)
        || firstName.toString().toLowerCase().includes(queryLowered)
        || lastName.toString().toLowerCase().includes(queryLowered)
        || _status.toString().toLowerCase().includes(queryLowered)
                ) {
                  result.push(x)
                }
              })
              dataFromAPI = result
            }
            /*
          const filteredData = dataFromAPI.filter(
            user =>
              user.userId
          ) */

            const sortedData = dataFromAPI
            if (sortDesc) sortedData.reverse()

            resolve({
              data: paginateArray(sortedData, perPage, page),
              totalCount: dataFromAPI.length,
            })
          })
          .catch(error => reject(error))
      })
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${baseURL}/api/User/GetById?userId=${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUserOld(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/apps/user/users/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addUser(ctx, userData) {
      console.log('UserData', userData)
      const payload = {
        firstName: userData.firstName,
        lastName: userData.lastName,
        password: userData.password,
        userName: userData.userName,
      }
      return new Promise((resolve, reject) => {
        axios
          .post(`${baseURL}/api/User/AddOrUdpate`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteShop(ctx, { id, status, commistion }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`${baseURL}/api/Shop/Delete`, {
            params: {
              shopId: id,
              status,
              commission_rate: commistion,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
